<template>
  <div>
    <router-link :to="{ name: 'conversations_conversations' }">
      <message-outline-icon />

      <span
        v-if="unseenCount"
        class="unseen-count"
      >
        <template v-if="unseenCount < 100">
          {{ unseenCount }}
        </template>
        <template v-else>
          99+
        </template>
      </span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Messages',
  computed: {
    read() {
      return this.$root.chatRead;
    },
    unseenCount() {
      return Object.keys(this.unseenRooms).length;
    },
    unseenRooms() {
      const rooms = {};
      this.$root.chatConversations.filter(c => (
        !c.read
        && !(this.read.find(i => i === c.last_message.id))
        && c.last_message.sender_id !== this.userData.id
      )).forEach((c) => {
        rooms[c.room] = (rooms[c.room] || 0) + 1;
      });
      return rooms;
    },
  },
};
</script>

<style lang="scss" scoped>
  div {
    position: relative;
  }
  .message-outline-icon {
    font-size: 1.5rem;
    color: var(--blue-dark);
    margin-right: 10px;
  }
</style>
